module.exports = __webpack_public_path__ + "img/LogoUp.49c6b09a.svg";